<template>
  <div
    ref="el"
    class="ti-form-element"
    :class="{
      ['ti-form-element' + formElement.field.cssClass]:
        formElement.field.cssClass,
      ['ti-form-element--with-modal']:
        formElement.tooltip && formElement.tooltip.modal,
      ['ti-form-element--radio']: formElement.type === 'Radio',
    }"
    @click="scrollToElement($event, formElement, el)"
    :id="formElement.key"
  >
    <template v-if="formElement.type === 'Date'">
      <wb-datepicker-control>
        <wb-input-control
          :error="formElement.options.valid == false && dirty"
          :success="formElement.options.valid"
        >
          <wb-input>
            <label>{{ $t(formElement.field.label || '') }}</label>

            <input
              type="date"
              v-model="formElement.field.selectedValue"
              :disabled="formElement.options.disabled"
            />
          </wb-input>
        </wb-input-control>
      </wb-datepicker-control>
    </template>

    <template v-else-if="formElement.type === 'Month'">
      <wb-month-picker-control
        :min.attr="formElement.field.min"
        :max.attr="formElement.field.max"
        :pattern.attr="formElement.field.placeholder"
        :preferred-language="i18n.language && i18n.language.split('-')[0]"
        @selected="onValueSelected($event)"
      >
        <p v-if="formElement.copy" class="ti-form-element__registration-copy">
          {{ $t(formElement.copy) }}
        </p>
        <wb-input-control
          :error="formElement.options.valid == false && dirty"
          :success="formElement.options.valid"
        >
          <wb-input>
            <label>{{ $t(formElement.field.label || '') }}</label>

            <input
              :value="formElement.field.selectedValue"
              type="text"
              :placeholder="formElement.field.placeholder"
              autocomplete="off"
              :disabled="formElement.options.disabled"
            />

            <wb-icon name="calendar" />
          </wb-input>
        </wb-input-control>
      </wb-month-picker-control>
    </template>

    <template v-else-if="formElement.type === 'SearchSelect'">
      <wb-search-select-control
        ref="searchSelectControl"
        :no-results-label="$t(formElement.field.noResultsLabel || '')"
        @selected="onValueSelected($event)"
      >
        <wb-input-control
          :error="formElement.options.valid == false && dirty"
          :success="formElement.options.valid"
        >
          <wb-input>
            <label>{{ $t(formElement.field.label || '') }}</label>

            <input
              :value="
                getSearchSelectLabel(formElement.field.selectedValue, element)
              "
              type="text"
              :disabled="formElement.options.disabled"
              autocomplete="off"
            />

            <wb-icon name="caret-down"></wb-icon>
          </wb-input>
        </wb-input-control>
      </wb-search-select-control>
    </template>

    <template
      v-else-if="
        formElement.type === 'Text' ||
        formElement.type === 'Email' ||
        formElement.type === 'Tel' ||
        formElement.type === 'Number'
      "
    >
      <wb-input-control
        :error="formElement.options.valid == false && dirty"
        :success="
          formElement.options.valid &&
          (dirty || formElement.field.selectedValue)
        "
      >
        <wb-input>
          <label>{{ $t(formElement.field.label || '') }}</label>
          <input
            v-model="formElement.field.selectedValue"
            :type="formElement.type.toLowerCase()"
            :disabled="formElement.options.disabled"
            :placeholder="$t(formElement.field.placeholder || '')"
            :pattern="formElement.type === 'Number' ? '[0-9]*' : undefined"
          />
        </wb-input>
      </wb-input-control>
    </template>

    <template
      v-else-if="formElement.type === 'Radio' && formElement.variant === null"
    >
      <span
        class="ti-form-element__radio-label"
        v-if="formElement.field.label"
        v-html="$t(formElement.field.label)"
      ></span>
      <wb-radio-control
        v-for="option in formElement.field.selectOptions"
        :key="option.value"
      >
        <label>
          <input
            type="radio"
            :name="formElement.key"
            :value="option.value"
            :checked="
              option.checked || option.value === formElement.field.selectedValue
            "
            :disabled="option.disabled"
            v-model="formElement.field.selectedValue"
          />
          {{ $t(option.label) }}
        </label>
      </wb-radio-control>
    </template>

    <template
      v-else-if="
        formElement.type === 'Radio' && formElement.variant === 'Tapbar'
      "
    >
      <div class="ti-form-element__tapbar-section">
        <div class="ti-form-element__tapbar-container">
          <wb-radio-control
            class="ti-form-element__radio-tapbar"
            v-for="option in formElement.field.selectOptions"
            :key="option.value"
          >
            <label
              class="ti-form-element__radio-tapbar-label"
              :class="{
                ['ti-form-element__radio-tapbar-label--selected']:
                  option.value === formElement.field.selectedValue,
              }"
            >
              <input
                type="radio"
                :name="formElement.key"
                :value="option.value"
                :checked="
                  option.checked ||
                  option.value === formElement.field.selectedValue
                "
                :disabled="option.disabled || formElement.options.disabled"
                v-model="formElement.field.selectedValue"
              />
              <span>{{ $t(option.label) }}</span>
            </label>
          </wb-radio-control>
        </div>
        <p
          v-if="formElement.field.copy"
          class="ti-form-element__tapbar-copy-text"
        >
          {{ $t(formElement.field.copy) }}
        </p>
      </div>
    </template>

    <template
      v-else-if="formElement.type === 'Radio' && formElement.variant === 'Card'"
    >
      <MeVehicleChooser
        @selectedVehicle="
          (vehicle) => (formElement.field.selectedValue = vehicle.finOrVin)
        "
        :userSelectedVehicle="formElement.field.selectedValue"
      />
    </template>

    <template v-else-if="formElement.type === 'RadioGrid'">
      <div class="ti-form-element__radio-grid-wrapper">
        <template
          v-for="(option, index) in formElement.field.selectOptions"
          :key="option.value"
        >
          <label
            class="ti-form-element__radio-grid"
            :class="{
              ['ti-form-element__radio-grid--selected']:
                option.value === formElement.field.selectedValue,
            }"
          >
            <input
              type="radio"
              :name="formElement.key"
              :value="option.value"
              :checked="option.checked"
              :disabled="option.disabled"
              tabindex="0"
              v-model="formElement.field.selectedValue"
            />
            <template v-if="option.value !== ''">
              <span
                class="ti-form-element__radio-grid-color"
                :style="{ 'background-color': option.visual?.values[0] }"
              ></span>
            </template>
            <template v-else>
              <span class="ti-form-element__radio-grid-default"></span>
            </template>
            <span class="ti-form-element__radio-grid-label">
              {{ $t(option.label) }}
            </span>
          </label>
        </template>
      </div>
    </template>

    <template v-else-if="formElement.type === 'Select'">
      <wb-select-control
        :error="formElement.options.valid == false && dirty"
        :success="formElement.options.valid"
      >
        <wb-select>
          <label>{{ $t(formElement.field.label || '') }}</label>

          <select
            v-model="formElement.field.selectedValue"
            :disabled="formElement.options.disabled"
          >
            <option
              v-if="formElement.field.defaultOption"
              selected="true"
              :value="formElement.field.defaultOption.value"
            >
              {{ $t(formElement.field.defaultOption.label) }}
            </option>

            <option
              v-for="option in formElement.field.selectOptions"
              v-bind:value="option.value"
            >
              {{ $t(option.label || option.label) }}
            </option>
            <optgroup
              v-if="currentMediaQuery === 'mq1' || currentMediaQuery === 'mq2'"
              label=""
            ></optgroup>
          </select>
        </wb-select>
      </wb-select-control>
    </template>

    <template v-else-if="formElement.type === 'Checkbox'">
      <wb-checkbox-control>
        <label>
          <input
            type="checkbox"
            v-model="formElement.field.selectedValue"
            :value="formElement.field.checkboxOption?.value"
            :name="formElement.field.checkboxOption?.value"
            :checked="formElement.field.checkboxOption?.checked"
            :disabled="formElement.field.checkboxOption?.disabled"
          />
          <span
            v-html="$t(formElement.field.checkboxOption?.label || '')"
          ></span>
        </label>
      </wb-checkbox-control>
    </template>

    <template v-else-if="formElement.type === 'Textarea'">
      <wb-input-control
        :error="formElement.options.valid == false && dirty"
        :success="
          formElement.options.valid &&
          (dirty || formElement.field.selectedValue)
        "
      >
        <p class="ti-form-element__textarea-copy">{{ $t(formElement.copy) }}</p>
        <wb-input>
          <label>{{ $t(formElement.field.label || '') }}</label>

          <textarea v-model="formElement.field.selectedValue"></textarea>
        </wb-input>
      </wb-input-control>
    </template>

    <template v-else-if="formElement.type === 'LicensePlate'">
      <wb-license-plate
        @changed="onValueSelected($event)"
        class="ti-form-element__license-plate"
      >
        <span class="ti-form-element__license-plate-tag">{{
          $t('i18n.licensePlate.code')
        }}</span>
        <wb-input-control
          :error="formElement.options.valid == false && dirty"
          :success="
            formElement.options.valid &&
            (dirty || formElement.field.selectedValue)
          "
        >
          <wb-input>
            <label>{{ $t(formElement.field.label || '') }}</label>
            <input
              :value="formElement.field.selectedValue"
              :type="'text'"
              :placeholder="formElement.field.placeholder"
            />
          </wb-input>
        </wb-input-control>
      </wb-license-plate>
    </template>

    <template v-else>
      <wb-control-error id="wrong-input-type">
        Wrong Input Type
      </wb-control-error>
    </template>

    <wb-control-error
      v-if="
        !formElement.options.disabled &&
        !formElement.options.valid &&
        dirty &&
        errorMessages.length > 0
      "
      v-for="message in errorMessages"
      :key.attr="message"
    >
      {{ message }}
    </wb-control-error>

    <ModalComponent
      v-if="formElement.tooltip && formElement.tooltip.modal"
      :modal="formElement.tooltip.modal"
      :label="formElement.tooltip.label"
      :theme="modalTheme.Highlight"
      @modalClosed="modalClosed"
    />
    <Transition name="fade" mode="out-in">
      <MeLogin
        class="ti-form-element__me-login"
        :vinHint="true"
        v-if="formElement.key === 'Vin' && showMeLoginHint"
        @close="closeVinHint"
      />
    </Transition>
    <span
      class="ti-form-element__disclaimer"
      v-if="formElement.disclaimer"
      v-html="$t(formElement.disclaimer)"
    ></span>
    <TooltipComponent
      v-if="formElement.tooltip && !formElement.tooltip.modal"
      :text="formElement.tooltip.label"
    />
  </div>
</template>
<script lang="ts" setup>
import { onMounted, ref, Ref, watch } from 'vue';
import { FormElement, Modal, SearchSelectOptionsGroup } from '@tradein/api';

import {
  checkValidState,
  getFormElementValueFormLocalStorage,
} from '../form/utils';
import { ModalTheme } from '../../utils/interfaces';
import setup from '../../composables/setup';
import i18nManager from '../../composables/i18nManager';

import ModalComponent from '../modal/modal.vue';
import TooltipComponent from '../tooltip/tooltip.vue';
import {
  setSearchSelectOptions,
  getSearchSelectLabel,
  scrollToElement,
  showMercedesVinHint,
  setVinHintTimestamp,
} from './utils';
import MeVehicleChooser from '../me-vehicle-chooser/me-vehicle-chooser.vue';
import MeLogin from '../me-login/me-login.vue';

interface SearchSelectElement extends HTMLElement {
  options: SearchSelectOptionsGroup[];
}

const { currentMediaQuery } = setup();
const { i18n } = i18nManager();

const props = defineProps<{
  element: FormElement;
}>();
const emit = defineEmits(['modalClosed', 'updateFormElement']);

const formElement: Ref<FormElement> = ref({} as FormElement);
const dirty = ref(false);
const debounce: Ref<any> = ref(null);
const errorMessages: Ref<string[]> = ref([]);
const modalTheme = ref(ModalTheme);
const showMeLoginHint = ref<boolean>(false);

const el: Ref<Element> = ref({} as Element);
const searchSelectControl: Ref<SearchSelectElement> = ref(
  {} as SearchSelectElement,
);

const onSelectedValueChanged = (): void => {
  const state = checkValidState(formElement.value);
  const translatedErrorMessages = state.errorMessages.map((errorMessage) =>
    i18n.value.t(errorMessage).toString(),
  );
  formElement.value.options.valid = state.valid;
  // dirty.value = true;
  errorMessages.value = translatedErrorMessages.filter(
    (message, index) => translatedErrorMessages.indexOf(message) === index,
  );
};

onMounted(() => {
  if (formElement.value.options.display) {
    setSearchSelectOptions(searchSelectControl, props.element);
    formElement.value.field.selectedValue = formElement.value.field
      .selectedValue
      ? formElement.value.field.selectedValue
      : getFormElementValueFormLocalStorage(formElement.value);
    formElement.value.field.selectedValue && onSelectedValueChanged();
  }
});

watch(
  () => props.element,
  (val: FormElement) => {
    formElement.value = val;
    if (formElement.value.options.disabled) {
      formElement.value.field.selectedValue = '';
      dirty.value = false;
    }

    setSearchSelectOptions(searchSelectControl, props.element);
  },
  { immediate: true, deep: true },
);

watch(
  () => formElement.value.field.selectedValue,
  () => {
    if (
      formElement.value.type === 'Text' ||
      formElement.value.type === 'Email' ||
      formElement.value.type === 'Tel' ||
      formElement.value.type === 'Number'
    ) {
      dirty.value = false;
      clearTimeout(debounce.value);
      debounce.value = setTimeout(() => {
        dirty.value = true;
      }, 1000);
    } else {
      dirty.value = true;
    }

    if (formElement.value.key === 'Vin') {
      formElement.value.field.selectedValue =
        formElement.value.field.selectedValue.toUpperCase();
    }

    onSelectedValueChanged();

    // Check for Mercedes Vin and show Mercedes Me Login
    if (
      formElement.value.key === 'Vin' &&
      showMercedesVinHint(
        formElement.value.field.selectedValue,
        formElement.value.options.valid,
      )
    ) {
      showMeLoginHint.value = true;
    } else {
      showMeLoginHint.value = false;
    }

    emit('updateFormElement', formElement.value);
  },
);

const closeVinHint = () => {
  showMeLoginHint.value = false;
  setVinHintTimestamp();
};

const onValueSelected = (
  e: CustomEvent<{ label: string; value: string }>,
): void => {
  if (e.detail) {
    dirty.value = true;

    formElement.value.field.selectedValue = e.detail.value
      ? e.detail.value
      : (e.detail as any as string);
  } else {
    formElement.value.field.selectedValue = '';
  }
};

const modalClosed = (modal: Modal): void => {
  emit('modalClosed', modal);
};
</script>
<style lang="scss" src="./form-element.scss"></style>
